import { render } from "./DepotsManagement.vue?vue&type=template&id=582d9a48&scoped=true"
import script from "./DepotsManagement.vue?vue&type=script&lang=js"
export * from "./DepotsManagement.vue?vue&type=script&lang=js"

import "./DepotsManagement.vue?vue&type=style&index=0&id=582d9a48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-582d9a48"]])

export default __exports__